import React from 'react';
import moment from 'moment';
import Countdown from 'react-countdown';

function CountdownTimer({ limit = '2021-12-03', messageExpired = 'Payment has expired', message = '', setExpired }) {
  const date = moment();
  const dateDiff = moment(limit);
  const res = dateDiff.diff(date);
  const Completionist = () => <span>{messageExpired}</span>;

  const renderer = (props) => {
    if (props.completed) {
      setExpired(props.completed);
      return <Completionist />;
    } else {
      return (
        <span>
          {message} {props.formatted.hours}:{props.formatted.minutes}:{props.formatted.seconds}
        </span>
      );
    }
  };

  return <Countdown date={Date.now() + res} renderer={renderer} />;
}

export default CountdownTimer;
